$(document).ready(function () {
	const result_title = $('.roi-total-result-title');
	const roi_result = document.querySelector('.roi-total-result');

	if (roi_result && result_title.length) {
		const observer = new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				if (mutation.type === 'characterData' || mutation.type === 'childList') {
					result_title.text($(roi_result).text());
				}
			});
		});

		observer.observe(roi_result, { childList: true, characterData: true, subtree: true });
	}
});

